import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SettingsModule } from '@/store/modules/settings';
var version = require('element-ui/package.json').version; // element-ui version from node_modules
var ORIGINAL_THEME = '#409EFF'; // default color
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "chalk", '');
    // The content of theme-chalk css
    _defineProperty(_this, "theme", '');
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "defaultTheme",
    get: function get() {
      return SettingsModule.theme;
    }
  }, {
    key: "onDefaultThemeChange",
    value: function onDefaultThemeChange(value) {
      this.theme = value;
    }
  }, {
    key: "onThemeChange",
    value: function () {
      var _onThemeChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
        var _this2 = this;
        var oldValue, themeCluster, originalCluster, message, url, getHandler, chalkHandler, styles;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (value) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              oldValue = this.chalk ? this.theme : ORIGINAL_THEME;
              themeCluster = this.getThemeCluster(value.replace('#', ''));
              originalCluster = this.getThemeCluster(oldValue.replace('#', ''));
              message = this.$message({
                message: '  Compiling the theme',
                customClass: 'theme-message',
                type: 'success',
                duration: 0,
                iconClass: 'el-icon-loading'
              });
              if (this.chalk) {
                _context.n = 2;
                break;
              }
              url = "https://unpkg.com/element-ui@".concat(version, "/lib/theme-chalk/index.css");
              _context.n = 2;
              return this.getCSSString(url, 'chalk');
            case 2:
              getHandler = function getHandler(variable, id) {
                return function () {
                  var originalCluster = _this2.getThemeCluster(ORIGINAL_THEME.replace('#', ''));
                  var newStyle = _this2.updateStyle(_this2[variable], originalCluster, themeCluster);
                  var styleTag = document.getElementById(id);
                  if (!styleTag) {
                    styleTag = document.createElement('style');
                    styleTag.setAttribute('id', id);
                    document.head.appendChild(styleTag);
                  }
                  styleTag.innerText = newStyle;
                };
              };
              chalkHandler = getHandler('chalk', 'chalk-style');
              chalkHandler();
              styles = [].slice.call(document.querySelectorAll('style'));
              styles = styles.filter(function (style) {
                var text = style.innerText;
                return new RegExp(oldValue, 'i').test(text) && !/Chalk Variables/.test(text);
              });
              styles.forEach(function (style) {
                var innerText = style.innerText;
                if (typeof innerText !== 'string') return;
                style.innerText = _this2.updateStyle(innerText, originalCluster, themeCluster);
              });
              this.$emit('change', value);
              message.close();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onThemeChange(_x) {
        return _onThemeChange.apply(this, arguments);
      }
      return onThemeChange;
    }()
  }, {
    key: "updateStyle",
    value: function updateStyle(style, oldCluster, newCluster) {
      var newStyle = style;
      oldCluster.forEach(function (color, index) {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index]);
      });
      return newStyle;
    }
  }, {
    key: "getCSSString",
    value: function getCSSString(url, variable) {
      var _this3 = this;
      return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            _this3[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '');
            resolve();
          }
        };
        xhr.open('GET', url);
        xhr.send();
      });
    }
  }, {
    key: "getThemeCluster",
    value: function getThemeCluster(theme) {
      var tintColor = function tintColor(color, tint) {
        var red = parseInt(color.slice(0, 2), 16);
        var green = parseInt(color.slice(2, 4), 16);
        var blue = parseInt(color.slice(4, 6), 16);
        if (tint === 0) {
          // when primary color is in its rgb space
          return [red, green, blue].join(',');
        } else {
          red += Math.round(tint * (255 - red));
          green += Math.round(tint * (255 - green));
          blue += Math.round(tint * (255 - blue));
          return "#".concat(red.toString(16)).concat(green.toString(16)).concat(blue.toString(16));
        }
      };
      var shadeColor = function shadeColor(color, shade) {
        var red = parseInt(color.slice(0, 2), 16);
        var green = parseInt(color.slice(2, 4), 16);
        var blue = parseInt(color.slice(4, 6), 16);
        red = Math.round((1 - shade) * red);
        green = Math.round((1 - shade) * green);
        blue = Math.round((1 - shade) * blue);
        return "#".concat(red.toString(16)).concat(green.toString(16)).concat(blue.toString(16));
      };
      var clusters = [theme];
      for (var i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
      }
      clusters.push(shadeColor(theme, 0.1));
      return clusters;
    }
  }]);
}(Vue);
__decorate([Watch('defaultTheme', {
  immediate: true
})], default_1.prototype, "onDefaultThemeChange", null);
__decorate([Watch('theme')], default_1.prototype, "onThemeChange", null);
default_1 = __decorate([Component({
  name: 'ThemePicker'
})], default_1);
export default default_1;